module.exports = __webpack_public_path__ + "img/book-003.81fc162a.png";